import React from 'react';
import {Link} from 'react-router-dom';
import AurBarStripe from '../../../common/aur-bar-stripe/AurBarStripe';

const ProgressBarStripe: React.FC = () => {
  return (
    <div style={{marginBottom: '64px'}}>
      <h1>AurBarStripe</h1>
      <Link to="/demo">Return</Link>
      <hr />
      <div style={{marginBottom: '8px'}}>
        In Progress - 75%
        <AurBarStripe state="in-progress" percent={75} />
        In Queue
        <AurBarStripe state="in-queue" percent={75} />
        Failed
        <AurBarStripe state="failed" percent={60} />
        Completed
        <AurBarStripe state="completed" percent={100} />
      </div>
    </div>
  );
};

export default ProgressBarStripe;
